import { MAX_UPLOAD_FILE_SIZE } from 'constants/file';
import { PromiseStatus } from 'constants/promise';

export const getMessageText = (filesNames, messageBase) => {
  if (!filesNames.length) {
    return;
  }

  const messageBeginning = filesNames.length > 1 ? 'Files are' : 'File is';

  return `${messageBeginning} ${messageBase}: ${filesNames.join(', ')}`;
};

const checkFilesForAlreadyExistence = (newFiles, addedFiles, uploadedFiles, allowedFileMimeTypes) =>
  [...newFiles].reduce(
    (acc, file) => {
      const { type, size, name } = file;

      const isValid = allowedFileMimeTypes.includes(type) && size <= MAX_UPLOAD_FILE_SIZE;

      if (!isValid) {
        acc.invalidFilesNames.push(name);

        return acc;
      }

      const isFileAlreadyAdded = !!addedFiles.find(file => file.name === name);

      if (isFileAlreadyAdded) {
        acc.alreadyAddedFilesNames.push(name);

        return acc;
      }

      const isFileAlreadyUploaded = !!uploadedFiles.find(file => file.name === name);

      if (isFileAlreadyUploaded) {
        acc.alreadyUploadedFilesNames.push(name);

        return acc;
      }

      acc.filesForAdding.push(file);

      return acc;
    },
    {
      filesForAdding: [],
      invalidFilesNames: [],
      alreadyAddedFilesNames: [],
      alreadyUploadedFilesNames: [],
    },
  );

export const getFulfilledFiles = files =>
  files.filter(({ status }) => status === PromiseStatus.FULFILLED);

export const getFilesForAdding = (
  newFiles,
  addedFiles,
  uploadedFiles,
  onError,
  allowedFileMimeTypes,
) => {
  const { filesForAdding, alreadyAddedFilesNames, alreadyUploadedFilesNames, invalidFilesNames } =
    checkFilesForAlreadyExistence(newFiles, addedFiles, uploadedFiles, allowedFileMimeTypes);

  if (
    alreadyAddedFilesNames.length ||
    alreadyUploadedFilesNames.length ||
    invalidFilesNames.length
  ) {
    onError(invalidFilesNames, alreadyAddedFilesNames, alreadyUploadedFilesNames);
  }

  return filesForAdding;
};
